import { injectReducer } from '../../store/reducers'

import NotFoundDetected from './components/NotFoundDetected'

export default (store) => ({
  path : 'not_found',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */


      /*  Add the reducer to the store on key 'counter'  */
      //injectReducer(store, { key: 'counter', reducer })

      /*  Return getComponent   */
      cb(null, NotFoundDetected)

    /* Webpack named bundle   */
    }, 'notfounddetected')
  }
})



// WEBPACK FOOTER //
// ./src/routes/NotFoundDetected/index.js